import styles from './UpsaleReview.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import { ReviewSlide } from '../ReviewSlide/ReviewSlide';
import { Title } from '../Title/Title';
export const UpsaleReview = ({content, paginationStatus})=>{
  if(!content){
    return;
  }
  const { title, slides,type } = content;
  const swiperProps = {
    spaceBetween: 20,
    slidesPerView: 1,
    className: styles.slider,
    modules: [Autoplay, Pagination],
    autoplay: { delay: 3000, disableOnInteraction: false },
    autoHeight: true,
    loop: true,
  };
  if (paginationStatus) {
    swiperProps.pagination = { clickable: true };
  }
  return (
    <div className={styles.wrapper} >
        {title && <Title className={styles.title} dangerouslySetInnerHTML={{ __html:title }} tag="h2"/>}
        {slides &&
          <Swiper {...swiperProps} >
            {slides.map((slide, index) => {
              return (
                <SwiperSlide key={index}>
                  <ReviewSlide slide={slide}
                  type={type || null}
                  />
                </SwiperSlide>
              )
            })}
          </Swiper>
        }
    </div>
  )
}